<template>
  <div class="flex items-center relative">
    <input type="text"
      class="input rounded w-full h-12"
      :placeholder="placeholder"
      v-model="value"
      readonly
      @click="$emit('click')" />

    <svg width="24" height="24" class="flex-none absolute icon">
      <use xlink:href="/img/sprite.svg#ic_chevron-down" />
    </svg>
  </div>
</template>

<script>
export default {
  props: ['value', 'placeholder']
}
</script>

<style scoped>
.icon {
  right: 12px;
}
</style>
